import { Link } from "react-router-dom";
import IconInput from "../inputs/IconInput";
import { CustomComponentProps } from "utils/types/generalTypes";

export type MapPagesHeaderProps = CustomComponentProps & {
    title: "Map" | "Places" | "#Hashtag";
    filterVal: string;
    setFilterVal: React.Dispatch<React.SetStateAction<string>>;
    removeSearch?: boolean;
};

const MapPagesHeader = ({
    title,
    filterVal,
    setFilterVal,
    removeSearch = false,
    className,
    style
}: MapPagesHeaderProps) => {
    return (
        <div className={`map-pages-header ${className}`} style={style}>
            <div className="box-heading mt-20 mb-30">
                <Link
                    to="/map"
                    className={`button${title == "Map" ? " is-active" : ""}`}
                >
                    Map
                </Link>
                <Link
                    to="/map/places"
                    className={`button${title == "Places" ? " is-active" : ""}`}
                >
                    Places
                </Link>
                <Link
                    to="/map/hashtag"
                    className={`button${title == "#Hashtag" ? " is-active" : ""}`}
                >
                    #Hashtag
                </Link>
            </div>

            <div className="d-flex flex-j-between flex-a-center mb-20 w-full pr-10 pl-10">
                <h1>{title}</h1>
                {!removeSearch ? (
                    <IconInput
                        rounded
                        value={filterVal}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setFilterVal(e.target.value)}
                    />
                ) : (
                    <div></div>
                )}
            </div>
        </div>
    );
};

export default MapPagesHeader;
